// extracted by mini-css-extract-plugin
module.exports = {"location":"ChannelSelect_location__1CqMN","box":"ChannelSelect_box__1WLo-","flag__icon":"ChannelSelect_flag__icon__XIDqq"};